import { useQuery } from '@tanstack/react-query';
import { API_QUERY_KEYS } from 'consts';
import { useTranslation } from 'react-i18next';
import { getExtDocumentMeta } from '../requests';
import { GetExtDocumentMetaRequestType } from '../types';

export const useExtDocumentMeta = (
  docSlug: GetExtDocumentMetaRequestType['pathParams']['docSlug'],
) => {
  const { i18n } = useTranslation();

  return useQuery({
    queryKey: [API_QUERY_KEYS.extForm, docSlug],
    queryFn: () =>
      getExtDocumentMeta({
        pathParams: { docSlug },
        headers: {
          'x-app-locale': i18n.language,
        },
      }),
  });
};
